export enum IPaymentInfoType {
  PAID = "결제",
  CANCELED = "취소",
}

export interface IPaymentInfo {
  type: IPaymentInfoType;
  payUid: string;
  amount: number;
  updatedAt: string;
  createdAt: string;
}
